import React, { useState } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'

const ConfirmInactivateDialog = ({
  open,
  enrollment,
  courseId,
  onClose,
  onSuccess,
}) => {
  const snackbar = useSnackbar()
  const [loading, setLoading] = useState(false)

  const isActive = enrollment?.status === 'active'

  const handleConfirm = async () => {
    setLoading(true)
    try {
      await service.dponet.trainingEnrollment.changeStatus({
        courseId,
        enrollmentId: enrollment.id,
      })
      onSuccess()
    } catch {
      snackbar.open({
        message: `Erro ao ${isActive ? 'inativar' : 'ativar'} aluno.`,
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {isActive ? 'Inativar colaborador' : 'Ativar colaborador'}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {isActive
            ? 'Esta ação impedirá o acesso do usuário ao curso, mas o histórico e os certificados já emitidos serão preservados.'
            : 'Esta ação reativará o acesso do usuário ao curso.'}
        </Typography>
        {enrollment?.user?.name && (
          <Typography variant="body1">{enrollment.user.name}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmInactivateDialog
